/*******************************************************************************
 * PayPal Express Checkout
 *******************************************************************************/
export const paypalExpressCheckoutComponent = {
  bindings: { config: '<', container: '<', onClick: '&', onFail: '&' },
  controller: controller
};

/*------------*/
/* Controller */
/*------------*/
function controller($injector) {
  var $ctrl = this;
  var $svcs = { $ctrl: $ctrl };

  $ctrl.$onInit = function () {
    var pageReady = $injector.invoke(
      initPage,
      null,
      Object.assign($svcs, { $svcs })
    );

    /*----------------------------------------------*/
    /* Start the checkout process when JS is ready. */
    /*----------------------------------------------*/
    pageReady
      .then(function () {
        paypal.checkout.setup($ctrl.config.merchantID, {
          locale: 'en_US',
          environment: $ctrl.config.environment,
          container: $ctrl.container,
          click: function (event) {
            event.preventDefault();

            /*----------------------------------------------*/
            /* If clicked again without reloading the       */
            /* page, close the previous flow.               */
            /*                                              */
            /* https://stackoverflow.com/a/57779923/2245849 */
            /*----------------------------------------------*/
            if (paypal.checkout.started) paypal.checkout.closeFlow();
            paypal.checkout.started = false;

            /*--------------------------------------------*/
            /* Call the server to make SetExpressCheckout */
            /* call and start the in-context checkout.    */
            /*--------------------------------------------*/
            $ctrl.onClick().then((data) => {
              paypal.checkout.started = true;
              paypal.checkout.initXO();
              paypal.checkout.startFlow(data.token);
            });
          }
        });
      })

      /*----------------------------------------------*/
      /* Fail if JS could not be loaded or activated. */
      /*----------------------------------------------*/
      .catch((reason) => $ctrl.onFail({ $reason: reason }));
  };
}

/*******************************************************************************
 * initPage */
/**
 * Loads browser page resources. Loads Express Checkout javascript file and returns
 * `window.checkoutReady` as a promise resolved when load is complete.
 *
 * @returns {Promise} Resolved when page resources have been loaded.
 *                    Rejected if script fails to load.
 *******************************************************************************/
/* @ngInject */ function initPage($ctrl, $interval, $q) {
  /*------------------------------------------------------------*/
  /* Initialize the browser page for use with Express Checkout. */
  /*------------------------------------------------------------*/
  if (!window.checkoutReady) {
    var head = angular.element(document.querySelector('head'));

    /*-----------------------------------------------------------------*/
    /* Disable Quirks Mode and Compatibility View in Internet Explorer */
    /*-----------------------------------------------------------------*/
    head.prepend(
      angular.element('<meta http-equiv="X-UA-Compatible" content="IE=edge" />')
    );

    /*----------------------------------------------------------*/
    /* Style the payment button(s) to remove the text under it. */
    /*----------------------------------------------------------*/
    head.append(
      angular.element(
        '<style>.paypal-button-tag-content { display:none !important; }</style>'
      )
    );

    /*-------------------------------------------*/
    /* Add script tag to load 'checkout.js'      */
    /* from PayPal and add load/error listeners. */
    /*-------------------------------------------*/
    var src = '//www.paypalobjects.com/api/checkout.js';
    var head = document.querySelector('head');
    var script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', () => (window.scriptLoaded = true));
    script.addEventListener('error', () => (window.scriptLoaded = false));
    head.appendChild(script);

    window.checkoutReady = $q(function (resolve, reject) {
      /*---------------------------------------------------------*/
      /* PayPal script calls 'paypalCheckoutReady()' when ready. */
      /*---------------------------------------------------------*/
      window.paypalCheckoutReady = () => (window.scriptReady = true);

      /*------------------------------------*/
      /* Wait for script file to be loaded. */
      /*------------------------------------*/
      var timer = $interval(
        function () {
          if (!angular.isUndefined(window.scriptLoaded)) {
            $interval.cancel(timer);

            if (window.scriptLoaded) {
              /*------------------------------------------------*/
              /* Wait for 'paypalCheckoutReady()' to be called. */
              /*------------------------------------------------*/
              timer = $interval(
                function () {
                  if (window.scriptReady) {
                    $interval.cancel(timer);
                    resolve();
                  }
                },
                10,
                50,
                false
              );

              /*-------------------------------------------------*/
              /* If the timer runs out, something must be wrong. */
              /*-------------------------------------------------*/
              timer.then(() => reject('PayPal Checkout did not activate.'));
            } else reject(`Script file '${src}' could not be loaded.`);
          }
        },
        100,
        100,
        false
      );
    });
  }
  return window.checkoutReady;
}
